import { css } from '@emotion/react';
import { getColor } from '@atlassiansox/wpl-utils';

const productInformationText = css`
  color: ${getColor('n800')};
  font-family: var(--bxp-charlie-text-font-family);
  font-size: 16px;
  font-style: normal;
  text-transform: none;
  line-height: 24px;
  letter-spacing: 0;
  white-space: nowrap;
  font-weight: 400;
`;

export const productFamilyNameText = css`
  color: ${getColor('n800')};
  font-family: var(--bxp-charlie-text-font-family);
  font-size: 16px;
  font-style: normal;
  text-transform: none;
  font-weight: 600;
  line-height: 24px;
`;

const pricingMessageText = css`
  ${productInformationText}
  font-size: 14px;
  line-height: 18px;
`;

export const pricingMessageContainer = css`
  ${pricingMessageText}
  display: flex;
  padding: 0px 0px 32px 52px;
  align-items: flex-start;
  gap: 16px;
  white-space: wrap;
  word-break: break-word;
  width: 804px;
`;
